import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AccountService } from './api/account.service';
import { AccountRepairerService } from './api/accountRepairer.service';
import { AdminEmailService } from './api/adminEmail.service';
import { AuthService } from './api/auth.service';
import { BrandService } from './api/brand.service';
import { CaseDisplayErrorService } from './api/caseDisplayError.service';
import { CategoryService } from './api/category.service';
import { ContactLogService } from './api/contactLog.service';
import { CountryService } from './api/country.service';
import { CustomerService } from './api/customer.service';
import { CustomerCaseService } from './api/customerCase.service';
import { DashboardService } from './api/dashboard.service';
import { DeadlineService } from './api/deadline.service';
import { ErrorTypeService } from './api/errorType.service';
import { LanguageService } from './api/language.service';
import { MessageService } from './api/message.service';
import { NotificationService } from './api/notification.service';
import { ProductService } from './api/product.service';
import { PurchaseOrderService } from './api/purchaseOrder.service';
import { PurposeService } from './api/purpose.service';
import { RepairerCaseService } from './api/repairerCase.service';
import { RepairshopService } from './api/repairshop.service';
import { RepairshopCaseService } from './api/repairshopCase.service';
import { ReportService } from './api/report.service';
import { RoleClaimsService } from './api/roleClaims.service';
import { ServiceProviderCaseService } from './api/serviceProviderCase.service';
import { SystemMessageService } from './api/systemMessage.service';
import { TestApiService } from './api/testApi.service';
import { UserProductService } from './api/userProduct.service';
import { UtilitiesService } from './api/utilities.service';
import { VoteService } from './api/vote.service';
import { WebhookService } from './api/webhook.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
